import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { Flex } from "@radix-ui/themes";
import { Dialog as DialogRadix } from "radix-ui";

import { theme } from "@themes/themes";

const overlayShow = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`;

const contentShow = keyframes`
    from { opacity: 0; transform: translate(-50%, -48%) scale(0.96); }
    to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
`;

const Overlay = styled(DialogRadix.Overlay)`
  background-color: ${theme.color("black-a9")};
  position: fixed;
  inset: 0;
  animation: ${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 99;
`;

const Content = styled(DialogRadix.Content)`
  overflow: auto;
  background-color: ${theme.color("gray-2")};
  border-radius: 6px;
  border: 1px solid ${theme.color("accent-7")};
  box-shadow: var(--shadow-6);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 500px;
  max-height: 85vh;
  z-index: 99;
  animation: ${contentShow} 150ms cubic-bezier(0.16, 1, 0.3, 1);

  &:focus {
    outline: none;
  }
`;

const Close = styled(DialogRadix.Close)`
  &:hover {
    cursor: pointer;
  }
`;

const Trigger = styled(DialogRadix.Trigger)`
  background: none;
  padding: 0px;
  border: none;
`;

const Title = styled(DialogRadix.Title)`
  margin: 0;
  font-weight: 500;
  font-size: 18px;
`;

const Description = styled(DialogRadix.Description)`
  margin: 0;
`;

const Header = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${theme.color("gray-5")};
  padding: 24px;
`;

export const Dialog = {
  Overlay,
  Content,
  Close,
  Trigger,
  Title,
  Description,
  Header,
  Portal: DialogRadix.Portal,
  Root: DialogRadix.Root,
};
